export enum I18nKeyEnum {
    TITLE = 'title',
    LAST_NAME = 'name',
    FIRST_NAME = 'first_name',
    CANCEL = 'cancel',
    COUNTRY = 'country',
    NUMBER = 'number',
    SALUTATION = 'salutation',
    WEBSITE = 'WEBSITE',
    ERROR_FIRST_NAME_REQUIRED = 'error_first_name_required',
    ERROR_LAST_NAME_REQUIRED = 'error__last_name_required',
    ERROR_INVALID_NUMBER = 'error_invalid_number',
    ERROR_REQUIRED = 'error_required',
    ERROR_NUMBER_REQUIRED = 'error_number_required',
    COMPANY = 'company',
    EMAIL = 'email',
    LETS_START = 'lets_start',
    ACCOUNT_READY = 'account_ready',
    WEBSITE_TITLE = 'website_title',
    SETUP_SMART_ASSISTANT = 'setup_smart_assistant',
    KNOWLEDGE_BASE_TITLE = 'knowledge_base_title',
    CALL_SCENARIO_TITLE = 'call_scenario_title',
    CONTACTS_TITLE = 'call_contacts_title',
    RECIPIENTS_TITLE = 'recipients_title',
    FORWARDING_TITLE = 'forwarding_title',
    WEBSITE_CRAWLING_INFO = 'website_crawling_info',
    CRAWLING_IN_PROGRESS = 'crawling_in_progress',
    CRAWLING_DONE = 'crawling_done',
    NO_HUMAN_ERROR = 'no_human_error',
    GENERAL_SETTINGS_INFO = 'general_settings_info',
    SELECT_VOICE_BOT_LANGUAGE = 'select_language',
    SELECT_VOICE_BOT_GENDER = 'select_gender',
    SELECT_VOICE_BOT_AGE = 'select_age',
    VOICE_BOT_TYPE = 'voice_bot_type',
    SAVE = 'save',
    GREETING = 'greeting',
    ENGLISH = 'english',
    GERMAN = 'german',
    ANY = 'any',
    MALE = 'male',
    FEMALE = 'female',
    YOUNG = 'young',
    MIDDLE_AGED = 'middle_aged',
    OLD = 'old',
    DEFAULT_GREETING = 'default_greeting',
    KNOWLEDGE_BASE_INFO = 'knowledge_base_info',
    KNOWLEDGE_BASE_INTRO = 'knowledge_base_intro',
    TEST_NOW_TITLE = 'test_now_title',
    CALLBACK_NUMBER_LABEL = 'callback_number_label',
    WHATS_APP_CONTACT = 'whats_app_contact',
    RECEIVE_CALL_NOTE_AS = 'receive_call_note_as',
    CALLBACK_NOW_BTN = 'callback_now_btn',
    LANDING_PAGE_TOP_ROW = 'landing_page_top_row',
    LANDING_PAGE_TITLE = 'landing_page_title',
    LANDING_PAGE_INFO = 'landing_page_info',
    LANDING_PAGE_NO_PAYMENT = 'landing_page_no_payment',
    START = 'start',
    ENTER_YOUR_WEBSITE = 'enter_your_website',
    YOUR_WEBSITE = 'your_website',
    YOUR_EMAIL = 'your_email',
    YOUR_PHONE = 'your_phone',
    DSGVO = 'dsgvo',
    SMART_ASSISTANT_SETUP = 'smart_assistant_setup',
    ANALYSE_YOUR_WEBSITE = 'analyse_your_website',
    CALL_SCENARIO_INFO = 'call_scenario_info',
    TITLE_MISSING = 'title_missing',
    OPEN = 'open',
    CREATE_CALL_SCENARIO = 'create_call_scenario',
    DESCRIBE_CALL_SCENARIO = 'describe_call_scenario',
    CALL_SCENARIOS = 'call_scenarios',
    CALL_SCENARIO = 'call_scenario',
    EXPAND_ALL = 'expand_all',
    COLLAPSE_ALL = 'collapse_all',
    ADD_PROPERTY = 'add_property',
    DESCRIBE_PROPERTY = 'describe_property',
    RECEIVE_CALL_NOTE_EMAIL = 'receive_call_note_email',
    RECEIVE_CALL_NOTE_WHATSAPP = 'receive_call_note_whatsapp',
    ERROR_PARAPHRASE_DETAIL = 'error_paraphrase_detail',
CALLBACK_NUMBER_INFO = 'callback_number_info',
    LETS_CONTINUE = 'lets_continue',
    CONTACT_ME_BTN = 'contact_me_btn',
    HOW_WAS_IT = 'how_was_it',
    RATED = 'rated',
    MORE_FEEDBACK = 'more_feedback',
    DETAILED_FEEDBACK = 'detailed_feedback',
    THX_TESTING_TITLE = 'thx_testing_title',
    THX_TESTING_TEXT = 'thx_testing_text',
    VOICE_ASSISTANT_NOT_AVAILABLE = 'voice_assistant_not_available',
    CALL_SCENARIO_EXAMPLE = 'call_scenario_example',
}

export type I18nKey = I18nKeyEnum;
export type Language = LanguageEnum;

export enum LanguageEnum {
    DE = 'DE',
    EN = 'EN'
}

export type Translation = {
    [key in I18nKey]: I18nTranslation
};

export type I18nTranslation = {
    [lang in Language]: string;
}

export const translations: Translation = {
    [I18nKeyEnum.TITLE]: {
        [LanguageEnum.DE]: 'Starten Durch mit Ihrer AI Telefonassistentin',
        [LanguageEnum.EN]: 'Setup your AI driven personal phone-assistant'
    },
    [I18nKeyEnum.CREATE_CALL_SCENARIO]: {
        [LanguageEnum.DE]: 'Lege einen neuen Anrufgrund an',
        [LanguageEnum.EN]: 'Create a new call scenario'
    },
    [I18nKeyEnum.DESCRIBE_CALL_SCENARIO]: {
        [LanguageEnum.DE]: 'Beschreibe einen Anrufgrund in einem Text',
        [LanguageEnum.EN]: 'Describe the call scenario for a call in a text'
    },
    [I18nKeyEnum.CALL_SCENARIOS]: {
        [LanguageEnum.DE]: 'Anrufgründe',
        [LanguageEnum.EN]: 'Call scenarios'
    },
    [I18nKeyEnum.CALL_SCENARIO]: {
        [LanguageEnum.DE]: 'Anrufgrund',
        [LanguageEnum.EN]: 'Call scenario'
    },
    [I18nKeyEnum.FIRST_NAME]: {
        [LanguageEnum.DE]: 'Vorname',
        [LanguageEnum.EN]: 'Firstname'
    },
    [I18nKeyEnum.CALL_SCENARIO_INFO]: {
        [LanguageEnum.DE]: 'Beschreibung von Anrufgründen',
        [LanguageEnum.EN]: 'Description of call scenarios'
    },
    [I18nKeyEnum.ERROR_INVALID_NUMBER]: {
        [LanguageEnum.DE]: 'Ungültige Telefonnummer',
        [LanguageEnum.EN]: 'Invalid phone number'
    },
    [I18nKeyEnum.ERROR_NUMBER_REQUIRED]: {
        [LanguageEnum.DE]: 'Bitte fügen Sie Ihre Nummer ein',
        [LanguageEnum.EN]: 'Please add your phone number'
    },
    [I18nKeyEnum.OPEN]: {
        [LanguageEnum.DE]: 'Öffnen',
        [LanguageEnum.EN]: 'Open'
    },
    [I18nKeyEnum.COUNTRY]: {
        [LanguageEnum.DE]: 'Land',
        [LanguageEnum.EN]: 'Country'
    },
    [I18nKeyEnum.TITLE_MISSING]: {
        [LanguageEnum.DE]: 'Was fehlt noch zum Weitermachen?',
        [LanguageEnum.EN]: 'What is still missing to continue?'
    },
    [I18nKeyEnum.CANCEL]: {
        [LanguageEnum.DE]: 'Abbrechen',
        [LanguageEnum.EN]: 'Cancel'
    },
    [I18nKeyEnum.NUMBER]: {
        [LanguageEnum.DE]: 'lokale Nummer',
        [LanguageEnum.EN]: 'local number'
    },
    [I18nKeyEnum.ERROR_FIRST_NAME_REQUIRED]: {
        [LanguageEnum.DE]: 'Bitte tragen Sie Ihren Vornamen ein',
        [LanguageEnum.EN]: 'Please add your name'
    },
    [I18nKeyEnum.ERROR_LAST_NAME_REQUIRED]: {
        [LanguageEnum.DE]: 'Bitte tragen Sie Ihren Nachnamen ein',
        [LanguageEnum.EN]: 'Please add your name'
    },
    [I18nKeyEnum.LAST_NAME]: {
        [LanguageEnum.DE]: 'Nachname',
        [LanguageEnum.EN]: 'Lastname'
    },
    [I18nKeyEnum.ANALYSE_YOUR_WEBSITE]: {
        [LanguageEnum.DE]: 'Analyse Ihrer Website',
        [LanguageEnum.EN]: 'Analyse your website'
    },
    [I18nKeyEnum.SALUTATION]: {
        [LanguageEnum.DE]: 'Anrede',
        [LanguageEnum.EN]: 'Salutation'
    },
    [I18nKeyEnum.WEBSITE]: {
        [LanguageEnum.DE]: 'Ihre Website',
        [LanguageEnum.EN]: 'Your website'
    },
    [I18nKeyEnum.ERROR_REQUIRED]: {
        [LanguageEnum.DE]: 'benötigt',
        [LanguageEnum.EN]: 'required'
    },
    [I18nKeyEnum.COMPANY]: {
        [LanguageEnum.DE]: 'Ihr Firmenname',
        [LanguageEnum.EN]: 'Your company name'
    },
    [I18nKeyEnum.EMAIL]: {
        [LanguageEnum.DE]: 'Emailadresse',
        [LanguageEnum.EN]: 'Email'
    },
    [I18nKeyEnum.LETS_START]: {
        [LanguageEnum.DE]: 'Und los...',
        [LanguageEnum.EN]: `Let's go`
    },
    [I18nKeyEnum.START]: {
        [LanguageEnum.DE]: 'Start',
        [LanguageEnum.EN]: `Start`
    },
    [I18nKeyEnum.SMART_ASSISTANT_SETUP]: {
        [LanguageEnum.DE]: 'Initialisierung Ihres SmartAssistant',
        [LanguageEnum.EN]: `Initialising your SmartAssistant`
    },
    [I18nKeyEnum.ACCOUNT_READY]: {
        [LanguageEnum.DE]: 'Ihr Konto ist bereit',
        [LanguageEnum.EN]: 'Your account is ready'
    },
    [I18nKeyEnum.WEBSITE_TITLE]: {
        [LanguageEnum.DE]: 'Webseite',
        [LanguageEnum.EN]: 'Website'
    },
    [I18nKeyEnum.SETUP_SMART_ASSISTANT]: {
        [LanguageEnum.DE]: 'Allgemeine Einstellungen',
        [LanguageEnum.EN]: 'Setup your smart assistant'
    },
    [I18nKeyEnum.KNOWLEDGE_BASE_TITLE]: {
        [LanguageEnum.DE]: 'Wissensdatenbank',
        [LanguageEnum.EN]: 'Knowledge base'
    },
    [I18nKeyEnum.CALL_SCENARIO_TITLE]: {
        [LanguageEnum.DE]: 'Anrufgründe',
        [LanguageEnum.EN]: `Call scenarios`
    },
    [I18nKeyEnum.RECIPIENTS_TITLE]: {
        [LanguageEnum.DE]: 'Anrufnotiz Empfänger',
        [LanguageEnum.EN]: 'Call note recipients'
    },
    [I18nKeyEnum.FORWARDING_TITLE]: {
        [LanguageEnum.DE]: 'Weiterleitungen',
        [LanguageEnum.EN]: 'Forwardings'
    },
    [I18nKeyEnum.CONTACTS_TITLE]: {
        [LanguageEnum.DE]: 'Kontakte',
        [LanguageEnum.EN]: 'Contacts'
    },
    [I18nKeyEnum.WEBSITE_CRAWLING_INFO]: {
        [LanguageEnum.DE]: 'Status der Analyse Ihrer Webseite',
        [LanguageEnum.EN]: 'Status of the analysis of your website'
    },
    [I18nKeyEnum.CRAWLING_IN_PROGRESS]: {
        [LanguageEnum.DE]: 'läuft',
        [LanguageEnum.EN]: 'running'
    },
    [I18nKeyEnum.CRAWLING_DONE]: {
        [LanguageEnum.DE]: 'erledigt',
        [LanguageEnum.EN]: 'done'
    },
    [I18nKeyEnum.NO_HUMAN_ERROR]: {
        [LanguageEnum.DE]: 'Robot detection / no human',
        [LanguageEnum.EN]: 'Robot detection / no human'
    },
    [I18nKeyEnum.GENERAL_SETTINGS_INFO]: {
        [LanguageEnum.DE]: 'Allgmeine Einstellungen zum Sprachassistant',
        [LanguageEnum.EN]: 'General settings for the voice assistant'
    },
    [I18nKeyEnum.SELECT_VOICE_BOT_LANGUAGE]: {
        [LanguageEnum.DE]: 'Sprachassistant Sprache',
        [LanguageEnum.EN]: 'Voice assistant language'
    },
    [I18nKeyEnum.SELECT_VOICE_BOT_GENDER]: {
        [LanguageEnum.DE]: 'Sprachassistent Geschlecht',
        [LanguageEnum.EN]: 'Voice assistant gender'
    },
    [I18nKeyEnum.SELECT_VOICE_BOT_AGE]: {
        [LanguageEnum.DE]: 'Sprachassistent Alter',
        [LanguageEnum.EN]: 'Voice assistant age'
    },
    [I18nKeyEnum.VOICE_BOT_TYPE]: {
        [LanguageEnum.DE]: 'Sprachassistant Type',
        [LanguageEnum.EN]: 'Voice assistant type'
    },
    [I18nKeyEnum.SAVE]: {
        [LanguageEnum.DE]: 'Speichern',
        [LanguageEnum.EN]: 'Save'
    },
    [I18nKeyEnum.GREETING]: {
        [LanguageEnum.DE]: 'Begrüßung',
        [LanguageEnum.EN]: 'Greeting'
    },
    [I18nKeyEnum.ENGLISH]: {
        [LanguageEnum.DE]: 'Englisch',
        [LanguageEnum.EN]: 'english'
    },
    [I18nKeyEnum.GERMAN]: {
        [LanguageEnum.DE]: 'Deutsch',
        [LanguageEnum.EN]: 'german'
    },
    [I18nKeyEnum.ANY]: {
        [LanguageEnum.DE]: 'Jede',
        [LanguageEnum.EN]: 'any'
    },
    [I18nKeyEnum.MALE]: {
        [LanguageEnum.DE]: 'Männlich',
        [LanguageEnum.EN]: 'male'
    },
    [I18nKeyEnum.FEMALE]: {
        [LanguageEnum.DE]: 'Weiblich',
        [LanguageEnum.EN]: 'female'
    },
    [I18nKeyEnum.YOUNG]: {
        [LanguageEnum.DE]: 'Jung',
        [LanguageEnum.EN]: 'young'
    },
    [I18nKeyEnum.MIDDLE_AGED]: {
        [LanguageEnum.DE]: 'mittleres Alter',
        [LanguageEnum.EN]: 'middle aged'
    },
    [I18nKeyEnum.OLD]: {
        [LanguageEnum.DE]: 'Alt',
        [LanguageEnum.EN]: 'old'
    },
    [I18nKeyEnum.DEFAULT_GREETING]: {
        [LanguageEnum.DE]: 'Willkommen, wie kann ich Ihnen helfen?',
        [LanguageEnum.EN]: 'Welcome, how can I help you?'
    },
    [I18nKeyEnum.KNOWLEDGE_BASE_INFO]: {
        [LanguageEnum.DE]: 'Wissensdatenbank auf Ihrer Website',
        [LanguageEnum.EN]: 'Knowledgebase through your website'
    },
    [I18nKeyEnum.KNOWLEDGE_BASE_INTRO]: {
        [LanguageEnum.DE]: 'Hier sehen Sie die aufbereiteten Daten Ihrer Webseite.',
        [LanguageEnum.EN]: 'Here you can see the prepared data of your website'
    },
    [I18nKeyEnum.TEST_NOW_TITLE]: {
        [LanguageEnum.DE]: 'Testen Sie Ihren Smart Assistant jetzt',
        [LanguageEnum.EN]: 'Test your Smart Assistant now'
    },
    [I18nKeyEnum.CALLBACK_NUMBER_LABEL]: {
        [LanguageEnum.DE]: 'Ihre Rückrufnummer',
        [LanguageEnum.EN]: 'Your callback number'
    },
    [I18nKeyEnum.WHATS_APP_CONTACT]: {
        [LanguageEnum.DE]: 'WhatsApp',
        [LanguageEnum.EN]: 'Whatsapp'
    },
    [I18nKeyEnum.RECEIVE_CALL_NOTE_AS]: {
        [LanguageEnum.DE]: 'Anrufnotiz erhalten als',
        [LanguageEnum.EN]: 'Receive call note as'
    },
    [I18nKeyEnum.CALLBACK_NOW_BTN]: {
        [LanguageEnum.DE]: 'Rückruf jetzt starten',
        [LanguageEnum.EN]: 'Call back now'
    },
    [I18nKeyEnum.LANDING_PAGE_TOP_ROW]: {
        [LanguageEnum.DE]: 'SmartAssistant - Ihre KI für professionelle Anrufannahme',
        [LanguageEnum.EN]: 'SmartAssistant - your AI for professional call answering'
    },
    [I18nKeyEnum.LANDING_PAGE_TITLE]: {
        [LanguageEnum.DE]: 'Überlassen Sie die Anrufe dem Smart Assistant',
        [LanguageEnum.EN]: 'Leave the calls to the Smart Assistant'
    },
    [I18nKeyEnum.LANDING_PAGE_INFO]: {
        [LanguageEnum.DE]: 'Klingt wie ein Mensch - doch der SmartAssistant ist stets verfügbar, kosteneffizient, mehrsprachig und sorgt für exellente Gesprächsqualität',
        [LanguageEnum.EN]: 'Sounds like a human - but the SmartAssistant is always available, cost-efficient, multilingual and ensures excellent call quality'
    },
    [I18nKeyEnum.LANDING_PAGE_NO_PAYMENT]: {
        [LanguageEnum.DE]: 'Keine Zahlungsinformationen erfolderlich & keine Vertragsbindung',
        [LanguageEnum.EN]: 'No payment information required & no contract commitment'
    },
    [I18nKeyEnum.ENTER_YOUR_WEBSITE]: {
        [LanguageEnum.DE]: 'Bitte geben Sie Ihre eigene Webseite an:',
        [LanguageEnum.EN]: 'Please enter your own website:'
    },
    [I18nKeyEnum.YOUR_WEBSITE]: {
        [LanguageEnum.DE]: 'Ihre Webseite',
        [LanguageEnum.EN]: 'Your website'
    },
    [I18nKeyEnum.YOUR_EMAIL]: {
        [LanguageEnum.DE]: 'Ihre E-Mailedresse',
        [LanguageEnum.EN]: 'Your e-mail address'
    },
    [I18nKeyEnum.YOUR_PHONE]: {
        [LanguageEnum.DE]: 'Ihre Mobilenummer',
        [LanguageEnum.EN]: 'Your mobile number'
    },
    [I18nKeyEnum.DSGVO]: {
        [LanguageEnum.DE]: 'Die von Ihnen übermittelten Informationen werden gemäß unserer Datenschutzerklärung gespeichert, um Ihre Kontaktanfrage zu verarbeiten.',
        [LanguageEnum.EN]: 'The information you provide will be stored in accordance with our privacy policy in order to process your contact enquiry.'
    },
    [I18nKeyEnum.COLLAPSE_ALL]: {
        [LanguageEnum.DE]: 'Alles einklappen',
        [LanguageEnum.EN]: 'Collapse all'
    },
    [I18nKeyEnum.EXPAND_ALL]: {
        [LanguageEnum.DE]: 'Alle aufklappen',
        [LanguageEnum.EN]: 'Expand all'
    },
    [I18nKeyEnum.ADD_PROPERTY]: {
        [LanguageEnum.DE]: 'Sollen weitere anrufspezifische Daten erfasst werden?',
        [LanguageEnum.EN]: 'More call specific data to collect?'
    },
    [I18nKeyEnum.DESCRIBE_PROPERTY]: {
        [LanguageEnum.DE]: 'Beschreiben Sie in einem Text die zusätzlichen Daten',
        [LanguageEnum.EN]: 'Describe in a text the additional data'
    },
    [I18nKeyEnum.RECEIVE_CALL_NOTE_EMAIL]: {
        [LanguageEnum.DE]: 'Als Email an',
        [LanguageEnum.EN]: 'As email at'
    },
    [I18nKeyEnum.RECEIVE_CALL_NOTE_WHATSAPP]: {
        [LanguageEnum.DE]: 'Als WhatsApp Nachricht unter',
        [LanguageEnum.EN]: 'As WhatsApp message for:'
    },
    [I18nKeyEnum.ERROR_PARAPHRASE_DETAIL]: {
        [LanguageEnum.DE]: 'Analyse war nicht möglich - Bitte anders beschreiben',
        [LanguageEnum.EN]: 'Analysis was not possible - Please describe differently'
    },
    [I18nKeyEnum.CALLBACK_NUMBER_INFO]: {
        [LanguageEnum.DE]: 'Bitte geben Sie die Nummer ein unter der Sie den Testanruf erhalten will',
        [LanguageEnum.EN]: 'Please enter the number at which you would like to receive the test call'
    },
    [I18nKeyEnum.LETS_CONTINUE]: {
        [LanguageEnum.DE]: 'Kommen Sie an Board',
        [LanguageEnum.EN]: 'Let`s get on board'
    },
    [I18nKeyEnum.CONTACT_ME_BTN]: {
        [LanguageEnum.DE]: 'Kontaktieren Sie mich',
        [LanguageEnum.EN]: 'Contact me'
    },
    [I18nKeyEnum.HOW_WAS_IT]: {
        [LanguageEnum.DE]: 'Wie war es?',
        [LanguageEnum.EN]: 'How was it?'
    },
    [I18nKeyEnum.RATED]: {
        [LanguageEnum.DE]: 'Ihre Bewertung',
        [LanguageEnum.EN]: 'Your rated'
    },
    [I18nKeyEnum.MORE_FEEDBACK]: {
        [LanguageEnum.DE]: 'Haben Sie weiteres Feedback?',
        [LanguageEnum.EN]: 'Do you have any further feedback?'
    },
    [I18nKeyEnum.DETAILED_FEEDBACK]: {
        [LanguageEnum.DE]: 'Ihr Feedback',
        [LanguageEnum.EN]: 'Your feedback'
    },
    [I18nKeyEnum.THX_TESTING_TITLE]: {
        [LanguageEnum.DE]: 'Danke für Ihr testen',
        [LanguageEnum.EN]: 'Thank you for your testing'
    },
    [I18nKeyEnum.THX_TESTING_TEXT]: {
        [LanguageEnum.DE]: 'Wir hoffen, Sie hatten Spaß beim testen unseres Smart Assistant, wir werden umgehen mit Ihnen in Contact treten. Für weitere Fragen rufen Sie uns auch einfach direkt an: 0171122334455.',
        [LanguageEnum.EN]: 'We hope you enjoyed testing our Smart Assistant, we will be in touch with you shortly. If you have any further questions, simply call us directly: 0171122334455.'
    },
    [I18nKeyEnum.VOICE_ASSISTANT_NOT_AVAILABLE]: {
        [LanguageEnum.DE]: 'Für die oben ausgewählten Kriterien ist kein Sprachassistent verfügbar.',
        [LanguageEnum.EN]: 'No voice assistant is available for the above selected criteria.'
    },
    [I18nKeyEnum.CALL_SCENARIO_EXAMPLE]: {
        [LanguageEnum.DE]: 'Beispiel: Ich würde gerne Mitglied in Ihren Verein werden.',
        [LanguageEnum.EN]: 'Example: I would like to become a member of your organisation.'
    }
};
